module.exports = __webpack_public_path__ + "img/Docs@1x.dc0f3fff.svg";